module.exports = __webpack_public_path__ + "static/media/tti_avg_time_to_transfer@2x.0ba4414a.png";